import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import { tokens, success, GET, DELETE, getStorage, loading } from "../../components/CustomComponent.js";
import React, { Component } from "react";
import Pagination from '@mui/material/Pagination';
import { Modal } from "react-bootstrap";

const r_det = getStorage("role_detail")?.find(i => i.name === "role")?.role || [];
const [view_r, create_r, update_r, delete_r] = [r_det[0] === 1, r_det[1] === 1, r_det[2] === 1, r_det[3] === 1];

export default class Role extends Component {
    state = { modal_delete: false, page: 1, filter_data_search: "", data: null, role_id: "" };

    componentDidMount() {
        if (view_r) this.GetAll();
    }

    GetAll = async () => {
        loading(true);
        let r = await GET(tokens, `v1/TH/role-manage/filter-search/page/${this.state.page}`, { data_search: this.state.filter_data_search });
        if (r?.status) this.setState({ data: r.data });
        loading(false);
    };

    Delete = async () => {
        loading(true);
        let r = await DELETE(tokens, `v1/TH/role-manage/delete/${this.state.role_id}`, null);
        if (r?.status) {
            this.setState({ modal_delete: false, page: 1, filter_data_search: "" });
            success();
            this.GetAll();
        }
        loading(false);
    };

    render() {
        const s = this.state;
        return (
            <div className="w-100 min-vh-100 fade-in">
                <Navbar page1="หน้าหลัก" page2="ข้อมูลผู้ใช้" page3="บทบาทผู้ใช้" />

                <div className="body">
                    <div className="p-3">
                        <div className="card border-0 p-3">
                            <div className="d-flex row mx-0 align-items-center justify-content-between">
                                <h4 className="mb-3"><b>บทบาทผู้ใช้</b></h4>
                                {create_r && <button className="btn btn-primary px-4 mx-1 mb-3" onClick={() => window.location.href = "/create-role"}>เพิ่มบทบาท</button>}
                            </div>

                            {view_r && (
                                <div className="d-flex row mx-0 align-items-center justify-content-between">
                                    <div className="d-flex row mx-0">
                                        <input type="search" className="form-control wpx-200 bg-contain border-0 mx-1 mb-3" placeholder="พิมพ์คำค้นหา..." value={s.filter_data_search} onChange={(e) => this.setState({ filter_data_search: e.target.value })} />
                                        <button className="btn btn-primary px-3 mb-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>ค้นหา</button>
                                        <button className="btn btn-outline-primary px-3 mb-3 mx-1" onClick={() => this.setState({ filter_data_search: "", page: 1 }, this.GetAll)}>รีเซ็ท</button>
                                    </div>
                                </div>
                            )}

                            <div className="table-responsive">
                                <table className="table table-borderless table-striped">
                                    <thead>
                                        <tr className="bg-dark-blue text-white">
                                            <th className="text-left">บทบาท</th>
                                            <th className="text-left">รายละเอียด</th>
                                            {(update_r || delete_r) && <th className="text-center">จัดการ</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!s.data?.data?.length ? (
                                            <tr><td colSpan={3} className="text-center">ไม่มีข้อมูล</td></tr>
                                        ) : (
                                            s.data.data.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item.role_name || "-"}</td>
                                                    <td>{item.role_description || "-"}</td>
                                                    {(update_r || delete_r) && (
                                                        <td className="text-center d-flex">
                                                            {update_r && <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center mr-2"><label className="icon mx-2 text-primary pointer" onClick={() => window.location.href = "/update-role?id=" + item.role_id}>{"\uf304"}</label></label>}
                                                            {delete_r && <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center"><label className="icon mx-2 text-danger pointer" onClick={() => this.setState({ role_id: item.role_id, modal_delete: true })}>{"\uf2ed"}</label></label>}
                                                        </td>
                                                    )}
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {s.data?.data?.length > 0 && (
                                <div className="d-flex justify-content-between row mx-0 w-100 px-3">
                                    <div><label>แสดง {s.data.end_index} รายการ จาก {s.data.count} รายการ</label></div>
                                    <Pagination count={s.data.page_number} page={s.page} color="primary" showFirstButton showLastButton onChange={(e, v) => this.setState({ page: v }, this.GetAll)} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <Modal show={s.modal_delete} onHide={() => this.setState({ modal_delete: false })}>
                    <Modal.Header><Modal.Title><b>ยืนยันการลบผู้ใช้งาน</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        <div className="w-100 d-flex mb-3"><label>ท่านแน่ใจว่าต้องการลบข้อมูล หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้</label></div>
                        <div className="w-100 d-flex">
                            <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_delete: false })}>ยกเลิก</button></div>
                            <div className="w-50 p-1"><button className="btn btn-danger w-100" onClick={this.Delete}>ยืนยัน</button></div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}